<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="2" class="py-2">
                <span><b>Reported Comments</b></span>
              </b-col>
            </b-row>
            <b-row class="text-left" align-v="center">
              <b-col cols="12" md="2" class="pt-3">
                <b-dropdown
                  variant="outline-primary"
                  size="md"
                  id="dropdown-1"
                  :text="tableType"
                >
                  <b-dropdown-item
                    v-for="(item, i) in tableTypes"
                    :key="i"
                    @click="updateTable(item)"
                    >{{ item.name }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-col>
              <b-col cols="12" md="2">
                <span style="font-size: 12px">Please Select From Date:</span
                ><br />
                <b-form-input
                  class="pt-1"
                  v-model="from"
                  type="date"
                  id="date"
                  @change="dateSetting"
                ></b-form-input>
              </b-col>

              <b-col cols="12" md="2">
                <span style="font-size: 12px">Please Select To Date:</span
                ><br />
                <b-form-input
                  class=""
                  v-model="to"
                  type="date"
                  id="date"
                  @change="dateSetting"
                ></b-form-input>
              </b-col>
              <b-col cols="12" md="2" class="pt-3">
                <b-dropdown
                  variant="outline-primary"
                  size="sm"
                  id="dropdown-1"
                  :text="chartName"
                >
                  <b-dropdown-item
                    v-for="(item, i) in chartTypes"
                    :key="i"
                    @click="updateChart(item)"
                    >{{ item.name }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-col>
              <b-col cols="12" md="4" class="pt-3">
                <b-form @submit.prevent="getSearch">
                  <b-row>
                    <b-col cols="8">
                      <b-form-input
                        list="searchData"
                        v-model="searchKey"
                        placeholder="Search"
                        size="md"
                      ></b-form-input>
                      <!-- <datalist id="searchData">
                        <option v-for="(item,i) in searchData" :key="i">{{item.keyword}}</option>
                      </datalist> -->
                    </b-col>
                    <b-col cols="2" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="getSearch"
                        >Search</b-button
                      >
                    </b-col>
                    <b-col cols="1" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        class="px-2"
                        size="sm"
                        to="/Discussions?type=Reported"
                        >All</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="discussions"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
          >
            <template slot="case" slot-scope="data">
              <span v-if="data.item.incident.caseidentifier">{{
                data.item.incident.caseidentifier
              }}</span>
              <span v-else>{{ data.item.incident.caseid }}</span>
            </template>
            <template slot="discussion" slot-scope="data">
              <span v-if="data.item.discussion.text">{{
                data.item.discussion.text
              }}</span>
              <span v-else>-</span>
            </template>
            <template slot="createddate" slot-scope="data">
              <span v-if="data.item.createddate">{{
                formatDate(data.item.createddate)
              }}</span>
              <span v-else>-</span>
            </template>
            <template slot="comment" slot-scope="data">
              <span v-if="data.item.text">{{ data.item.text }}</span>
              <span v-else>-</span>
            </template>
            <template slot="reportedby" slot-scope="data">
              <span v-if="data.item.reports">{{
                data.item.reports.length
              }}</span>
              <span v-else>-</span>
            </template>
            <template slot="postedby" slot-scope="data">
              <span v-if="data.item.user">{{ data.item.user.name }}</span>
              <span v-else>-</span>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="discussions.length"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
            />
          </nav>
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      discussions: [],
      idset: [],
      idset1: [],
      from: null,
      to: null,
      chartName: "Filter",
      chartType: null,
      chartTypes: [
        { name: "Last 90 Days", value: 90 },
        { name: "Last 60 Days", value: 60 },
        { name: "Last 30 Days", value: 30 },
        { name: "Last 15 Days", value: 15 },
      ],
      tableTypes: [
        { name: "Reported", route: "/search/reportdiscussion" },
        { name: "Marked as Spam", route: "/search/discussion?status=Deleted" },
      ],
      tableType: "Reported",
      fields: [
        { key: "case", label: "Case Id", sortable: true },
        { key: "comment", label: "Comment", sortable: true },

        { key: "postedby", label: "Posted By", sortable: true },
        { key: "reportedby", label: "Reported By", sortable: true },
      ],
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      searchKey: null,
      searchData: [],
      previousIcon: true,
      nextIcon: true,
      route: null,
    };
  },
  mounted() {
    this.searchKey = this.$route.query.searchKey;
    this.from = this.$route.query.from;
    this.to = this.$route.query.to;
    this.tableType = this.$route.query.type;
    for (var i = 0; i < this.tableTypes.length; i++) {
      if (this.tableType == this.tableTypes[i].name) {
        this.route = this.tableTypes[i].route;
      }
    }
    this.chartType = this.$route.query.chartType;
    for (var i = 0; i < this.chartTypes.length; i++) {
      if (this.chartType == this.chartTypes[i].value) {
        this.chartName = this.chartTypes[i].name;
        return;
      }
    }
    this.mySearch();
  },
  watch: {
    "$route.fullpath": {
      handler: function () {
        this.mySearch();
      },
      deep: true,
    },
  },
  methods: {
    getSearch() {
      this.$router.push({
        path: "/Discussions",
        query: {
          type: this.$route.query.type,
          searchKey: this.searchKey,
          from: this.$route.query.from,
          to: this.$route.query.to,
          chartType: this.$route.query.chartType,
        },
      });
    },

    dateSetting() {
      this.$router.push({
        path: "/Discussions",
        query: {
          type: this.$route.query.type,
          searchKey: this.$route.query.searchKey,
          from: this.from,
          to: this.to,
          chartType: this.$route.query.chartType,
        },
      });
    },

    mySearch(item) {
      this.appLoading = true;

      axios({
        method: "GET",
        url: this.route,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // count: this.perPage,
          // page: this.currentPage,

          filter: this.chartType,
          keyword: this.searchKey,
          from: this.from,
          to: this.to,
        },
      })
        .then((response) => {
          this.discussions = response.data.data;
          for (var i = 0; i < this.discussions.length; i++) {
            this.idset[i] = this.discussions[i]._id;
            this.idset1[i] = this.discussions[i].incident._id;
          }
          this.appLoading = false;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },

    updateChart(item) {
      this.chartName = item.name;
      this.chartType = item.value;
      this.$router.push({
        path: "/Discussions",
        query: {
          type: this.$route.query.type,
          searchKey: this.$route.query.searchKey,
          from: this.$route.query.from,
          to: this.$route.query.to,
          chartType: this.chartType,
        },
      });
    },

    updateTable(item) {
      this.tableType = item.name;
      this.route = item.route;
      this.$router.push({
        path: "/Discussions",
        query: {
          type: this.tableType,
          searchKey: this.$route.query.searchKey,
          from: this.$route.query.from,
          to: this.$route.query.to,
          chartType: this.chartType,
        },
      });
    },

    rowClicked(item) {
      this.$router.push(
        "/Discussions/" +
          item.incident._id +
          "/" +
          item._id +
          "/" +
          this.idset +
          "/" +
          this.idset1
      );
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>


Password@2K20
